import React, { useState, useEffect, useRef } from "react";
import { Ripple } from "primereact/ripple";
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { getAppCurrencyType } from "../../../../../Utils/Common";
import { Section, sections, SubSection, SectionItem, SubSectionItem, SubSectionItemAmount, Preliminaries, preliminaries } from "./SOW/CustomSOW/SampleCustomSOW";


interface DownloadSowProps {
    isOpen: boolean;
    onClose: () => void;
}

const DownloadSOWTenderList: React.FC<DownloadSowProps> = ({
    isOpen,
    onClose,
}) => {

    const getCurrentDate = () => {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const year = today.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const currencySymbol = getAppCurrencyType();

    // const exportToPDF = () => {
    //     const element = document.getElementById('exportDocument');
    //     if (element) {
    //         const opt = {
    //             margin: 1,
    //             filename: 'document.pdf',
    //             image: { type: 'jpeg', quality: 0.98 },
    //             html2canvas: { scale: 2 },
    //             jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    //         };

    //         html2pdf().from(element).set(opt).save();
    //     }
    // };

    const handleDownloadSowDocument = () => {
    }

    const downloadSowModalHeader = (
        <div className="full_view_modal_header_inner">
            <h6 className="date_text">
                DATE : {getCurrentDate()}
            </h6>
            <h5>Schedule of work</h5>
            <div className="modal_btn_area">
                <button type="button" className="download_btn p-ripple"
                    onClick={handleDownloadSowDocument}>
                    <i className="bi bi-download"></i>
                    <Ripple />
                </button>

                <button type="button" className="close_modal_btn dark p-ripple"
                    onClick={onClose}>
                    <i className="bi bi-x-circle-fill"></i>
                    <Ripple />
                </button>
            </div>
        </div>
    )

    /* Cover page */
    const [coverPageBody, setCoverPageBody] = useState<string>('Erection of four storey building comprising provision of flexible A1 (retail) /A2 (financial and professional services) on the ground floor with 6 one bedroom and 3 two-bedroom flats on upper floors.');

    /* Contents */
    const [sectionData, setSectionData] = useState<Section[]>([]);

    /* Preliminaries */
    const [preliminariesData, setPreliminariesData] = useState<Preliminaries[]>([]);

    useEffect(() => {
        const fetchData = async () => {
            setSectionData(sections);
            setPreliminariesData(preliminaries);
        }
        fetchData();
    }, []);

    const getRowClassName = () => {
        return 'project_table_row';
    };

    const formatPrice = (value: number) => {
        return new Intl.NumberFormat('en-UK', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value);
    };

    return (
        <Dialog header={downloadSowModalHeader} headerClassName="full_view_modal_header" draggable={false}
            visible={isOpen} className="custom_modal_dialog modal_dialog_full" onHide={onClose} contentClassName="pt-2 pt-sm-2">
            <div className="custom_modal_body with_responsive" id="exportDocument">
                <article className="main_section_area view_only d-flex" style={{ minHeight: '60vh' }}>
                    <div className="cover_page_area">
                        <h2>Schedule of work</h2>
                        <h6>{coverPageBody}</h6>
                        <h5>At</h5>
                        <h5>258-260 LONDON ROAD <br />Croydon CRO 2TH</h5>
                        <br />
                        <h5>For <br />ABC LTD</h5>
                    </div>
                </article>

                {sections?.length > 0 && (
                    <article id="content" className="main_section_area view_only">
                        <div className="main_section_header">
                            <h6>Contents</h6>
                        </div>

                        <DataTable
                            value={sections}
                            size="small"
                            tableStyle={{ minWidth: '50rem' }}
                            className="page_table project_table view_only p-0 p-sm-2"
                            tableClassName="mb-1"
                            rowClassName={getRowClassName}
                            scrollable
                            scrollHeight={'75vh'}
                            emptyMessage="No data found"
                        >
                            <Column
                                header="Section no"
                                alignHeader={'center'}
                                body={(rowData: Section) => rowData.section_no ? <span className="flex_center">{rowData.section_no}</span> : '--'}
                                style={{ width: '15%' }}
                                className="table_column"
                            ></Column>
                            <Column
                                header="Content"
                                body={(rowData: Section) => rowData.section_name ? <span>{rowData.section_name}</span> : '--'}
                                style={{ width: '65%' }}
                                className="table_column"
                            ></Column>
                            <Column
                                header="Price"
                                alignHeader={'right'}
                                body={(rowData: Section) => rowData.section_amount !== null ?
                                    <span className="flex-end text-end text_no_wrap">
                                        {currencySymbol}&nbsp;{formatPrice(rowData.section_amount)}
                                    </span> : '--'}
                                style={{ width: '20%' }}
                                className="table_column text-end"
                            ></Column>
                        </DataTable>
                    </article>
                )}

                {sections.map((section) => (
                    <div key={section.section_id}>
                        {section?.sub_section_data?.length !== 0 && (
                            <React.Fragment>
                                <article id={`section${section?.section_no}`} key={section.section_id} className="main_section_area view_only">
                                    <div className="main_section_header">
                                        <h6>{section?.section_no}. {section?.section_name}</h6>
                                    </div>
                                    <DataTable
                                        value={section?.sub_section_data}
                                        size="small"
                                        tableStyle={{ minWidth: '50rem' }}
                                        className="page_table project_table view_only p-0 p-sm-2"
                                        tableClassName="mb-1"
                                        rowClassName={getRowClassName}
                                        scrollable
                                        scrollHeight={'75vh'}
                                        emptyMessage="No data found"
                                        key={section.section_id}
                                    >
                                        <Column
                                            header="Sub section no."
                                            alignHeader={'center'}
                                            body={(rowData) => rowData.sub_section_no ? <span className="flex_center">{rowData.sub_section_no}</span> : '--'}
                                            style={{ width: '15%' }}
                                            className="table_column"
                                        ></Column>

                                        <Column
                                            header="Sub section name"
                                            body={(rowData) => rowData.sub_section_name ? <span>{rowData.sub_section_name}</span> : '--'}
                                            style={{ width: '65%' }}
                                            className="table_column"
                                        ></Column>

                                        <Column
                                            header="Price"
                                            alignHeader={'right'}
                                            body={(rowData) => rowData.sub_section_amount !== null ?
                                                <span className="flex-end text-end text_no_wrap">
                                                    {currencySymbol}&nbsp;{formatPrice(rowData.sub_section_amount)}
                                                </span> : '--'}
                                            style={{ width: '20%' }}
                                            className="table_column text-end"
                                        ></Column>
                                    </DataTable>
                                </article>

                                {section.sub_section_data?.map((subSection) => (
                                    <React.Fragment>
                                        {subSection.sub_section_item_data?.length !== 0 && (
                                            <article id={`subsection${subSection?.sub_section_no}`} key={section.section_id} className="main_section_area view_only">
                                                <div className="main_section_header">
                                                    <h6>Section {section?.section_no} ({subSection?.sub_section_no + ' ' + subSection?.sub_section_name}) </h6>
                                                </div>

                                                <DataTable
                                                    value={subSection.sub_section_item_data}
                                                    size="small"
                                                    tableStyle={{ minWidth: '50rem' }}
                                                    className="page_table project_table view_only p-0 p-sm-2"
                                                    tableClassName="mb-1"
                                                    rowClassName={getRowClassName}
                                                    scrollable
                                                    scrollHeight={'75vh'}
                                                    emptyMessage="No data found"
                                                >
                                                    <Column
                                                        header="Item no."
                                                        alignHeader={'center'}
                                                        body={(rowData: SubSectionItem) => rowData.item_no ? <span className="flex_center">{rowData.item_no}</span> : '--'}
                                                        style={{ width: '8%' }}
                                                        className="table_column"
                                                    ></Column>

                                                    <Column
                                                        header="Item name"
                                                        body={(rowData: SubSectionItem) => rowData.item_name ? <span>{rowData.item_name}</span> : '--'}
                                                        style={{ width: '30%' }}
                                                        className="table_column"
                                                    ></Column>

                                                    <Column
                                                        header="Unit no."
                                                        alignHeader={'center'}
                                                        style={{ width: '10%' }}
                                                        className="table_column"
                                                    ></Column>

                                                    <Column
                                                        header="Unit price"
                                                        alignHeader={'right'}
                                                        style={{ width: '12%' }}
                                                        className="table_column text-end"
                                                    ></Column>

                                                    <Column
                                                        header="Sub total"
                                                        alignHeader={'right'}
                                                        style={{ width: '12%' }}
                                                        className="table_column text-end"
                                                    ></Column>

                                                    <Column
                                                        header="Note"
                                                        alignHeader={'center'}
                                                        style={{ width: '28%' }}
                                                        className="table_column"
                                                    ></Column>
                                                </DataTable>
                                            </article>
                                        )}
                                    </React.Fragment>
                                ))}
                            </React.Fragment>
                        )}

                        {section?.section_item_data?.length !== 0 && (
                            <React.Fragment>
                                <article id={`section${section?.section_no}`} key={section.section_id} className="main_section_area view_only">
                                    <div className="main_section_header">
                                        <h6>{section?.section_no}.&nbsp;{section.section_name}</h6>
                                    </div>

                                    <DataTable
                                        value={section?.section_item_data}
                                        size="small"
                                        tableStyle={{ minWidth: '50rem' }}
                                        className="page_table project_table view_only p-0 p-sm-2"
                                        tableClassName="mb-1"
                                        rowClassName={getRowClassName}
                                        scrollable
                                        scrollHeight={'75vh'}
                                        emptyMessage="No data found"
                                    >
                                        <Column
                                            header="Item no."
                                            alignHeader={'center'}
                                            body={(rowData: SectionItem) => rowData.item_no ? <span className="flex_center">{rowData.item_no}</span> : '--'}
                                            style={{ width: '8%' }}
                                            className="table_column"
                                        ></Column>

                                        <Column
                                            header="Item name"
                                            body={(rowData: SectionItem) => rowData.item_name ? <span>{rowData.item_name}</span> : '--'}
                                            style={{ width: '30%' }}
                                            className="table_column"
                                        ></Column>

                                        <Column
                                            header="Unit no."
                                            alignHeader={'center'}
                                            style={{ width: '10%' }}
                                            className="table_column"
                                        ></Column>

                                        <Column
                                            header="Unit price"
                                            alignHeader={'right'}
                                            style={{ width: '12%' }}
                                            className="table_column text-end"
                                        ></Column>

                                        <Column
                                            header="Sub total"
                                            alignHeader={'right'}
                                            style={{ width: '12%' }}
                                            className="table_column text-end"
                                        ></Column>

                                        <Column
                                            header="Note"
                                            alignHeader={'center'}
                                            style={{ width: '28%' }}
                                            className="table_column"
                                        ></Column>
                                    </DataTable>
                                </article>
                            </React.Fragment>
                        )}
                    </div>
                ))}

                {preliminariesData?.length > 0 && (
                    <article id="preliminary" className="main_section_area view_only">
                        <div className="main_section_header">
                            <h6>Preliminaries</h6>
                        </div>
                        <DataTable
                            value={preliminariesData}
                            size="small"
                            tableStyle={{ minWidth: '50rem' }}
                            className="page_table project_table view_only p-0 p-sm-2"
                            tableClassName="mb-1"
                            rowClassName={getRowClassName}
                            scrollable
                            scrollHeight={'75vh'}
                            emptyMessage="No data found"
                        >
                            <Column
                                header="Ref no."
                                alignHeader={'center'}
                                body={(rowData) => rowData.ref_number ? <span className="flex_center">{rowData.ref_number}</span> : '--'}
                                style={{ width: '8%' }}
                                className="table_column"
                            ></Column>

                            <Column
                                header="Item name"
                                body={(rowData) => rowData.item_name ? <span>{rowData.item_name}</span> : '--'}
                                style={{ width: '30%' }}
                                className="table_column"
                            ></Column>

                            <Column
                                header="Item no."
                                alignHeader={'center'}
                                style={{ width: '10%' }}
                                className="table_column text-center ">
                            </Column>

                            <Column
                                header="Unit price"
                                alignHeader={'right'}
                                style={{ width: '12%' }}
                                className="table_column text-end"
                            ></Column>

                            <Column
                                header="sub total"
                                alignHeader={'right'}
                                style={{ width: '12%' }}
                                className="table_column text-end"
                            ></Column>

                            <Column
                                header="Note"
                                alignHeader={'center'}
                                style={{ width: '28%' }}
                                className="table_column"
                            ></Column>
                        </DataTable>
                    </article>
                )}
            </div>
        </Dialog>
    )
}

export default DownloadSOWTenderList;